<div class="carousel-controls">
  <button
    class="control-btn prev"
    *ngIf="showPrev"
    [disabled]="!canGoPrev"
    (click)="prev.emit()"
    aria-label="Previous Slide"
    title="Previous Slide"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 19L8 12L15 5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  <button
    class="control-btn next"
    *ngIf="showNext"
    [disabled]="!canGoNext"
    (click)="next.emit()"
    aria-label="Next Slide"
    title="Next Slide"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 5L16 12L9 19"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</div>
